import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { Button } from '@/shared/components/ui/Button';
import { Input } from '@/shared/components/ui/Input';
import { useChangePassword } from '../hooks/useSettings';

export function ChangePasswordForm() {
  const changePassword = useChangePassword();
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');

  const mismatch = confirm.length > 0 && newPassword !== confirm;
  const tooShort = newPassword.length > 0 && newPassword.length < 6;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!currentPassword || newPassword.length < 6 || newPassword !== confirm) return;
    changePassword.mutate(
      { currentPassword, newPassword },
      {
        onSuccess: () => {
          toast.success('Password updated.');
          setCurrentPassword('');
          setNewPassword('');
          setConfirm('');
        },
        onError: (err: any) =>
          toast.error(err.response?.data?.error || 'Failed to update password.'),
      },
    );
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <Input
        label="Current Password"
        name="current-password"
        type="password"
        value={currentPassword}
        onChange={(e) => setCurrentPassword(e.target.value)}
        autoComplete="current-password"
        required
      />
      <Input
        label="New Password"
        name="new-password"
        type="password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
        autoComplete="new-password"
        error={tooShort ? 'At least 6 characters' : undefined}
        required
      />
      <Input
        label="Confirm New Password"
        name="confirm-password"
        type="password"
        value={confirm}
        onChange={(e) => setConfirm(e.target.value)}
        autoComplete="new-password"
        error={mismatch ? 'Passwords do not match' : undefined}
        required
      />
      <div className="flex justify-end">
        <Button
          type="submit"
          loading={changePassword.isPending}
          disabled={!currentPassword || newPassword.length < 6 || newPassword !== confirm}
        >
          Update Password
        </Button>
      </div>
    </form>
  );
}
